<script setup lang="ts">
import { computed } from 'vue'
import { useRouter, type RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  to?: RouteLocationRaw | null
  ariaLabel?: string
  color?: string
}>()

const router = useRouter()

const resolvedColor = computed(() => props.color ?? 'grey-darken-2')

function goBack() {
  if (props.to) {
    router.push(props.to)
    return
  }
  router.back()
}
</script>

<template>
  <v-btn
    icon
    variant="text"
    :color="resolvedColor"
    :aria-label="ariaLabel ?? 'Voltar'"
    @click="goBack"
  >
    <v-icon icon="mdi-arrow-left" />
  </v-btn>
</template>
